function ConvertStringToBoolean(value) {
  return value === "true" ? true : false;
}

function ConvertBooleanToString(value) {
  return value ? "true" : "false";
}

export { ConvertStringToBoolean, ConvertBooleanToString };